import axios from 'axios'

const airtableApi = axios.create({
  baseURL: process.env.VUE_APP_ATARRAYA_AIRTABLE_URL,
  timeout: parseInt(process.env.VUE_APP_ATARRAYA_TIMEOUT)
})

export const state = {
  products: [],
}

export const getters = {
  products: (state) => state.products,
}

export const mutations = {
  ADD_PRODUCT(state, data) {
    state.products.push(data)
  }
}

export const actions = {
  async addProduct ({ commit }, data) {
    const response = await airtableApi.post('appJBtBPqPKVyaPwa/tbluBqBprblYX3JBb', data, {
      headers: { 'Authorization': 'Bearer ' + process.env.VUE_APP_ATARRAYA_AIRTABLE_TOKEN }
    })
    commit('ADD_PRODUCT', data)
    return response.data
  }
}
